import * as React from 'react';

import { BaseComponent } from '../BaseComponent';
import { ArStore, ArStoreState } from '../../stores/ArStore';
import { PersistentStore } from '../../stores/PersistentStore';

interface ArFreezeButtonProps {}

class ArFreezeButton extends BaseComponent<ArFreezeButtonProps, ArStoreState & {barRight: boolean}> {
    public componentWillMount(): void {
        this.addStoreListener(ArStore, this.onChange);
        this.addStoreListener(PersistentStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element | null {
        if (!this.state.arDevice || !this.state.started) {
            return null;
        }

        return (
            <div className={this.getClassName()} onClick={ArStore.core.onToggleCameraFreeze}/>
        );
    }

    protected getClassName = (): string => {
        const baseClassName: string = 'ar-freeze-button';
        return `${baseClassName}${this.state.cameraIsFrozen ? ` ${baseClassName}-frozen` : ''}${this.state.barRight ? ` ${baseClassName}-bar-right` : ''}`;
    };

    protected onChange = (): void => {
        this.setState({...ArStore.getState(), barRight: PersistentStore.getState().sidebarPosition === 'right'});
    };
}

export default ArFreezeButton;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ar/ArFreezeButton.tsx